/* eslint-disable quotes */
module.exports = [
    '$scope',
    '$rootScope',
    '$translate',
    '$location',
    'Notify',
    '_',
    'Features',
    'SurveysSdk',
function (
    $scope,
    $rootScope,
    $translate,
    $location,
    Notify,
    _,
    Features,
    SurveysSdk
) {

    // Change layout class
    $rootScope.setLayout('layout-b');
    // Redirect to home if not authorized
    if ($rootScope.hasManageSettingsPermission() === false) {
        return $location.path('/');
    }
    $translate('nav.posts_and_entities').then(function (title) {
        $scope.title = title;
        $scope.$emit('setPageTitle', title);
    });
    // Change mode
    $scope.$emit('event:mode:change', 'settings');

    Features.loadFeatures()
    .then(function () {
        $scope.targetedSurveysEnabled = Features.isFeatureEnabled('targeted-surveys');
    });

    // Get all the forms for display
    //@QUESTION-jan26: WHY?
    $scope.refreshForms = function () {
        if ($location.path('/settings/surveys')) {
            return SurveysSdk.getSurveysTo('list_and_permissions').then(function (forms) {
                $scope.forms = forms;
                $scope.$apply();
            });
        }
    };

    $scope.deleteSurvey = function (survey) {
        Notify.deleteWithInput('survey', survey.name).then(function () {
            // If we haven't saved the survey
            // just go back to the surveys views
            if (!survey.id) {
                $location.url('/settings/surveys');
                return;
            }

            SurveysSdk.deleteSurvey(survey.id).then(function () {
                Notify.notify('notify.form.destroy_form_success', { name: survey.name });
                $scope.refreshForms();
            }, $scope.handleResponseErrors);
        });
    };

    $scope.handleResponseErrors = function (errorResponse) {
        Notify.apiErrors(errorResponse);
    };

    $scope.getLanguages = function (enabled_languages) {
        let languages = [enabled_languages.default, ...enabled_languages.available];
        languages = _.without(languages, "");
        if (languages.length > 0) {
            let languageString = languages.length > 1 ? $translate.instant('translations.languages') : $translate.instant('translations.language');
            _.each(languages,(language, index) => {
                let divider = index !== 0 ? ',' : ':';
                languageString = `${languageString + divider} ${$translate.instant(`languages.${language}`)}`;
        });
            return languageString;
        }
    }
    $scope.refreshForms();
}];
